import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CoreActions, SuperStore } from '@bilancio/root-store';
import { DxPopoverModule } from 'devextreme-angular/ui/popover';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-help',
    templateUrl: './help.component.html',
    styleUrls: ['./help.component.scss'],
    imports: [CommonModule, DxPopoverModule]
})
export class HelpComponent {
    visible = false;

    private readonly support =
        'https://mysupport.teamsystem.com/pagineinterne/login';
    private readonly teleassistenza =
        'https://www.teamsystem.com/teleassistenza';

    constructor(private readonly store: SuperStore) {}

    show(event: Event) {
        this.visible = true;
        event.stopPropagation();
    }

    hidden(event: Event, urlIndex: number) {
        this.visible = false;

        switch (urlIndex) {
            case 0:
                this.store.dispatch(CoreActions.readSignupMysupport());
                break;
            case 1:
                const win1 = window.open(this.support, '_blank');
                if (win1) {
                    win1.opener = null;
                }
                break;
            case 2:
                const win2 = window.open(this.teleassistenza, '_blank');
                if (win2) {
                    win2.opener = null;
                }
                break;
        }

        event.stopPropagation();
    }
}
